import React from 'react'
import { Table } from 'react-bootstrap'

import DropdownActionButton from '../components/action_button/DropdownActionButton'
import PosTaskStatusChip from './PosTaskStatusChip'
import {
  checkValue,
  getClientOrAttribute,
  getFormattedDateOnly,
  getRecurrenceText,
  getTaskTypeLabel
} from './posTaskListHelpers'

export default function PosTaskDesktopTable({
  data,
  canWrite,
  onShow,
  onRequestClone,
  onRequestSuspend
}) {
  const actionListFor = (model) => [
    {
      disabled: model.suspended,
      text: 'Suspender',
      handler: () => onRequestSuspend(model)
    },
    {
      text: 'Crear copia',
      handler: () => onRequestClone(model)
    }
  ]

  return (
    <Table className="pos-task-table" hover responsive style={{ marginBottom: 0 }}>
      <colgroup>
        <col className="pos-task-table__col-code" />
        <col className="pos-task-table__col-client" />
        <col className="pos-task-table__col-type" />
        <col className="pos-task-table__col-mandatory" />
        <col className="pos-task-table__col-description" />
        <col className="pos-task-table__col-recurrence" />
        <col className="pos-task-table__col-expiration" />
        <col className="pos-task-table__col-status" />
        <col className="pos-task-table__col-action" />
      </colgroup>
      <thead className="table-header-gray-mui">
        <tr>
          <th className="vertical-align-middle">CÓDIGO</th>
          <th className="vertical-align-middle">CLIENTE</th>
          <th className="vertical-align-middle">TIPO</th>
          <th className="vertical-align-middle">OBLIGATORIA</th>
          <th className="vertical-align-middle">DESCRIPCIÓN</th>
          <th className="vertical-align-middle">RECURRENCIA</th>
          <th className="vertical-align-middle">EXPIRA</th>
          <th className="vertical-align-middle pos-task-table__status-cell">ESTADO</th>
          <th className="vertical-align-middle pos-task-table__action-header">ACCIÓN</th>
        </tr>
      </thead>
      <tbody>
        {data.length > 0 ? (
          data.map((model) => (
            <tr className="cursor-pointer" key={model.uuid} onClick={() => onShow(model.uuid)}>
              <td className="td-text-limited pos-task-table__code-cell" title={model.uuid}>
                {checkValue(model.short_uuid)}
              </td>
              <td className="td-text-limited pos-task-table__client-cell">
                <div className="text-limit-4-lines">
                  {checkValue(getClientOrAttribute(model))}
                </div>
              </td>
              <td className="td-text-limited">{checkValue(getTaskTypeLabel(model.task_type))}</td>
              <td className="td-text-limited">{model.is_mandatory_task ? 'SÍ' : 'NO'}</td>
              <td className="td-text-limited">{checkValue(model.description)}</td>
              <td className="td-text-limited">{checkValue(getRecurrenceText(model))}</td>
              <td className="td-text-limited">{getFormattedDateOnly(model.end_date)}</td>
              <td className="td-text-limited pos-task-table__status-cell">
                <div className="td-pos-task-status">
                  <PosTaskStatusChip status={model.status} />
                </div>
              </td>
              <td
                className="td-text-limited pos-task-table__action-cell"
                onClick={(event) => event.stopPropagation()}
              >
                {canWrite ? (
                  <DropdownActionButton
                    id={`btn-dropdown-${model.uuid}`}
                    list={actionListFor(model)}
                  />
                ) : (
                  '-'
                )}
              </td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={9} className="td-text-limited td-text-limited-space">
              No hay tareas en punto de venta disponibles.
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  )
}
